import type { Step } from "react-joyride";

export const rateFormTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຟອມສ້າງ/ແກ້ໄຂອັດຕາຄ່າສົ່ງ. ເລືອກໂຊນ, ນ້ຳໜັກຕ່ຳ–ສູງ (ກຣາມ) ແລະ ຄ່າຂົນສົ່ງ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="shipping-rate-zone"]',
    content: "ເລືອກໂຊນ — ບັງຄັບ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-rate-weight"]',
    content: "ນ້ຳໜັກຕ່ຳ ແລະ ນ້ຳໜັກສູງ (ກຣາມ). ຕ້ອງນ້ຳໜັກຕ່ຳນ້ອຍກວ່ານ້ຳໜັກສູງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-rate-amount"]',
    content: "ຄ່າຂົນສົ່ງ (ຫົວໜ່ວຍນ້ອຍສຸດ ເຊັ່ນ satang).",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-rate-submit"]',
    content:
      "ກົດ 'ບັນທຶກ' ເພື່ອບັນທຶກ ຫຼື 'ຍົກເລີກ' ເພື່ອກັບຄືນ.",
    placement: "top",
  },
];
